import module from 'nominas/nomina/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

const validaciones = [
  'cobro_impuesto_estatal',
  'comision_porcentaje_op',
  'comision_porcentaje_sa',
  'id_esquema',
  'id_metodo_calculo_comision',
  'id_metodo_calculo_suministro',
  'id_tipo_comision',
  'metodo_calculo_comision',
  'metodo_calculo_suministro',
  'tipo_comision',
]

const validacionesImpuestos = [
  'tipoId',
  'impuesto',
  'porcentaje',
]

const compararEsquemaImpuestos = (impuestosA, impuestosB) => {
  if (impuestosA.length !== impuestosB.length) return false

  impuestosA = orderBy(impuestosA, validacionesImpuestos)
  impuestosB = orderBy(impuestosB, validacionesImpuestos)

  return impuestosA.every((impuesto, index) => compararEsquemaImpuesto(impuesto, impuestosB[index]))
}

const compararEsquemaImpuesto = (a, b) => validaciones.every((key) => a[key] === b[key])

export class NominasNominaInformacionConfiguracionEditarPrincipal {
  data
  esquemas
  status
  onChange
  actualizado = false
  esquema = undefined

  $onChanges (changes) {
    if (changes.data || changes.esquemas) {
      if (this.data && this.data.id_esquema && Array.isArray(this.esquemas)) {
        this.esquema = this.esquemas.find((item) => item.id_esquema === this.data.id_esquema)
      } else {
        this.esquema = undefined
      }

      if (this.status && !this.status.calculado) {
        this.validar()
      }
    }
  }

  validar () {
    this.actualizado = this.data && this.esquema
      && validaciones.every((key) => this.data[key] === this.esquema[key])
      && compararEsquemaImpuestos(this.data.impuestos, this.esquema.impuestos)
  }

  actualizar () {
    if (this.esquema) {
      this.onChange({$event: {data: this.esquema}})
    }

    this.validar()
  }
}

module.component('nominasNominaInformacionConfiguracionEditarPrincipal', {
  controller: NominasNominaInformacionConfiguracionEditarPrincipal,
  template,
  bindings: {
    data: '<',
    status: '<',
    esquemas: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/informacion/configuracion/editar/principal/component.js